<template>
  <div style="width: 100%; height: 2px; margin-top: 8px; background-color: #FFB70A;"></div>
</template>

<script>
export default {
    name:'DividingLine',
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/common/dividing_line.vue